export const config = {
    rowSelection: false,
    fieldControl: false,
    columns: [
        {title: 'ID', dataIndex: 'id', width: 200},
        {title: '事件标题', dataIndex: 'title', width: 200, ellipsis: true},
        {title: '事件描述', dataIndex: 'description', width: 200,ellipsis: true},
        {title: '发放值类型', dataIndex: 'grantValueType', width: 200, render: 'grantRender'},
        {title: '状态', dataIndex: 'state', width: 120, render: 'switchRender'},
        {title: '最后更新人', dataIndex: 'modifiedByName', width: 200,},
        {title: '最后更新时间', dataIndex: 'lastUpdatedTime', width: 200, itemType: 'dateTime'},
        {title: '操作', dataIndex: 'action', fixed: 'right', width: 200, render: 'actionRender'},
    ],
    search: [
        {label: '标题', name: 'title'},
        {label: '状态', name: 'state', itemType: 'select', data:'stateList', key: 'value'},
    ],
    footer: [
        {label: '新增', type: 'primary', events: ['onClick:onAdd']}
    ]
}
